import * as yup from "yup";
import {stringRequired} from "yup/defaultValudations";

export const schema = yup.object().shape({
  mobilePhone: stringRequired(),
});

export const initialValues = {mobilePhone: ""};
